export const i18en = {
    settings: "Settings",
    consultation_locations: "Consultation locations",
    consultation_locations_plural: "Consultation location(s)",
    reasons_for_consultation: "Subcategory",
    categories: "Reason for examination",
    instructions: "Instructions",
    change_aperture_ranges: "Aperture range selection",//APERTURE RANGE SELECTION
    calendar: 'Calendar',
    modify_category: "edit a review reason",
    add_category: "Add review reason",
    validate: "Validate",
    modify: "Modify",
    success_modified: "successfully modified",
    success_added: "successfully added",
    success_updated: "successful update",
    select_doctor: "Select a doctor",
    select_location: "Select your consultation location",
    select_categoty: "Choose a review reason",
    select_speciality: "Choose a specialty for the exam",
    select_service: "Choose a subcategory",
    choose_service_to_make_it_available: 'Choose a service to make it available',
    passed_date: "The appointment date has passed. Choose another date.",
    select_patient: "Choose a patient",
    enter_addressing: "Enter address",
    enter_notes: "Notes",
    enter_firstname: "Enter your first name",
    enter_dob: 'Enter your date of birth',
    enter_lastname: "Enter last name",
    enter_ssn: "Invalid Social security number",
    enter_email: "Enter email",
    notes: "Permanent note",
    reason_consultation: "Subcategory",
    addressing: "Addressed by",
    hour: "Time",
    create_new_pattern: 'Create a new pattern',
    modify_new_pattern: "Modify a pattern",
    assign_to_Secretary: 'Assign to secretariat',
    add_a_payment: 'Add a payment',
    attach_a_document: 'Attach a document',
    delete_appointment: 'Delete appointment',
    appointment_moved: 'Move the appointment',
    payment_made: 'Paid',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    continue: "Continue",
    appointment_status: "Appointment status",
    action: "Action",
    first_appointment: "1st appointment",
    up_coming_appointments: "Upcoming appointment",
    appointment_completed: "Appointment completed",
    appointment_canceled: "Appointment canceled",
    emergency_appointments: "Urgent appointment",
    title: 'Title',
    enter_ur_description: "Enter a description (only visible internally)",
    repeat: "Repeat",
    create_new_opening: "Open a time slot",
    repeat_on: "Repeat",
    ends: "End",
    enter_title: "Enter title",
    modify_the_opening_ranges: "Modify the opening ranges",
    edit_opening: "Edit opening",
    view_opening: "view opening",
    status: "Status",
    view_appointment: "View appointment",
    edit_appointment: "Edit appointment",
    please_note: "PLEASE NOTE",
    select_file: "Choose file",
    already_have_slot: "This time slot is already available in this time slot",
    overlap_opening: "Note that this time slot is also selected on the calendar ",
    this: 'this',
    these: 'these',
    outside_opening_hours: "Your appointment is outside of business hours.",
    selected_past_day: "The selected date has passed",
    choose_category: "For what reason for examination would you like to make an appointment ?",
    choose_speciality: "Choose a specialty for your consultation",
    choose_service: "Choose a review reason",
    for_someone_else: "+ For someone else",
    who_appointment: "Who are you making this appointment for?",
    only_one_patient: "An appointment is made for only one person",
    authorized_personal: "I declare that I am the legal representative of my loved one, or that I am authorized to use Hypokrate services to manage their medical data on their behalf.",
    previous_step: "Previous step",
    appointment: "Appointment",
    appointment_make: "Make appointment",
    consultation_mode: "Consultation mode",
    consultation_category: "reason for consideration for your consultation",
    me: "me",
    create_appointment: 'Make an appointment',
    Mon: "Mon",
    Tues: "Tues",
    Wednes: "Wed",
    Thurs: "Thurs",
    Fri: "Fri",
    Saturday: "Sat",
    Sun: "Sun",
    never: "Never",
    the: "Until",
    visiable_to_patient: "Visible to the patient",
    visiable_to_me: "Visible only to me",
    add_service: "Add a service",
    All: "All",
    choose_file: "Choose file",
    no_file_chosen: "No file chosen",
    months: 'month',
    hours: 'hours',
    min: 'minutes',
    days: 'days',
    minutes: "minutes",
    consultation_type: "Consultation mode",
    in_office: 'In cabinet',
    in_teleconsultation: "In teleconsultation",
    at_home: "At home",
    enter: "Enter",
    are_u_sure: "Are you sure you want to continue?",
    name: 'Name',
    first_name: 'First name',
    social_num: 'Social security number',
    dob: 'Date of birth',
    email: 'Email address',
    address: 'Address',
    postal_city: 'Postcode, City',
    tele_port: 'Mobile phone',
    tele_domicile: 'Home phone',
    emergency_num: "Emergency number",
    previous: "previous",
    next: "Next",
    date: 'date',
    time: 'hour',
    atient: 'Patient',
    patient_contact_information: "Patient contact details",
    hide_patient_coordinates: "Hide patient details",
    are_you_sure_you_want_to_delete: "Are you sure you want to delete",
    are_you_sure: "Are you sure you want to",
    inactiver: "Deactivate",
    activer: "Activate",
    category: `Reason for examination`,
    choose_secretary: "Choose secretary",
    accept_declaration: "Accept the declaration to continue",
    time_slot_busy: "Another appointment is currently scheduled at the time you selected.",
    confirm: "Confirm",
    delete_appointment: 'Delete appointment',
    remove_secretary: 'Remove secretary',
    remove: 'remove',
    are_you_sure_secretary: 'Are you sure you want to revoke the designated secretary for this appointment?',
    choose_consultation_mode: 'Choose your consultation method',
    select_a_consultaion: 'Select a consultation method',
    service_already_exist: "This subcategory title already exists as an examination reason. Choose another title, or another examination reason.",
    category_already_exit: "This exam reason title already exists in this specialty. Choose another title or specialty.",
    doctor: 'Doctor',
    success: 'Success',
    failure: 'Failed',
    confirmed_appointment: 'Appointment confirmed',
    you_receive_mail: 'you have received a confirmation email',
    choose_patient: 'Choose a patient',
    search_patient: 'Search for a patient',
    no_record: 'No records found',
    create_patient: 'Create a new patient',
    pick_slot: "Choose the appointment time",
    add_a_new_category: "Add review reason",
    end_date_precedes_start_date: "The end date must not precede the start date",
    api_err_category_cant_delete: "This review pattern contains different subcategories. Start deleting these to be able to delete the review pattern later.",
    api_err_service_cant_delete: "This service is already linked to opening appointment bookings. You cannot delete it.",
    delete_category: "Delete Review Reason",
    delete_reason_for_conslt: "Delete Subcategory",
    are_you_sure_status_change: 'Are you sure you want to change the status of the appointment to ',
    status_change_attende: 'Are you sure you want to set the appointment to ',
    status_change_confirm: 'Are you sure you want to confirm the appointment',
    status_change_tele: `Are you sure you want to`,
    for_status: 'For Status: ',
    status_change: 'Change of appointment status',
    secretary_assigned: "RDV assigned me",
    upcoming_appointments: 'Upcoming appointment',
    past_appointments: 'Past appointments',
    create_category: "Please create a review reason in settings",
    create_service: "Please create a service in settings",
    specialty: "Speciality",
    attach_delete_confirm: 'Delete confirmation',
    are_you_sure_attach: 'Are you sure you want to delete the attachment?',
    color: `color`,
    Reason_for_consultation: 'Subcategory',
    Duration: 'Duration',
    online_booking: 'Online booking',
    man: 'Man',
    women: 'Woman',
    unknown: 'Unknown',
    add_consultation_place: "Add a consultation place",
    place: 'Place',
    facility_name: `Facility name`,
    appears_on_medicallink_profile: 'Appears on your MediKaLlink profile and in appointment reminders',
    postal_address: 'Postal address',
    public_practical_info: 'Public practical information',
    office_phone_number: 'Phone number',
    hide: 'HIDE',
    fax: 'Fax',
    accessibility: 'Accessibility',
    elevator: 'Elevator',
    floor: 'Floor',
    accessible_entrance: 'Disabled accessible',
    parking: 'Parking',
    none: 'None',
    operation_hours: `Opening hours`,
    add_hours: 'Add a time slot',
    of: 'From',
    has: 'to',
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    office_closed: 'The office is closed',
    summary: 'Summary',
    emergency_contact: `Emergency contact`,
    type: 'Type',
    phone_number: 'Phone number',
    agenda: `Agenda`,
    diaries: 'Diaries',
    create_new_calendar: `Create a new calendar`,
    location: `Location`,
    my_place_of_consultation: `Place of consultations`,
    other_place_of_consultation: `Other place of consultation`,
    calendar_name: `Calendar name`,
    personal_phone: 'Personal mobile number',
    direct_phone: 'Practitioner direct line',
    secretariat: 'Secretariat',
    sos_doctor: 'SOS Doctors',
    samu: 'SAMU',
    select: `select`,
    create_a_new: `Create new`,
    edit_a: `edit a`,
    location_name_empty: 'The location must be entered',
    select_location_address: "Select a location address from the drop-down list.",
    api_err_location_cant_delete: 'A calendar already exists for this location, so it cannot be deleted.',
    myself: 'Myself',
    medical_center: 'Medical center',
    office: 'Cabinet',
    clinic: 'Clinic',
    hospital: 'Hospital',
    associated_with: 'Associated with',
    start_end_must_differ: 'Start and end times cannot be the same',
    association_mandatory: 'The association field is mandatory',
    available: 'Available',
    none: 'None',
    display_settings: `Display Settings`,
    list_of_proposed_exams: `List of proposed exams`,
    floor: 'floor',
    entrance: 'entrance',
    parking: 'parking',
    accessible: 'accessible',
    not_accessible_entrance: 'not accessible to PRMs',
    with: 'with',
    emergency: 'In case of emergency, contact 1001',
    contact_info: 'Phone number: 1002',
    list_of_proposed_exams: `List of proposed exams`,
    present_establishment: `Presentation of the establishment`,
    add_picture: 'Add photos',
    chooseMedicin: 'Choose a doctor for your consultation',
    no_consultation_location: `No consultation location is available at the moment`,
    add_a_place: 'Add a place',
    no_data: 'No data',
    Next: 'Next',
    Previous: 'Previous',
    map_info: 'Map and access information',
    useful_info: 'Practical information',
    presentation_of_establishment: "Presentation of the establishment",
    opening_hours_contact: 'Opening hours and contact',
    hours_of_operation: 'Opening hours',
    emergency_contact: 'Emergency contact',
    contact_details: 'Contact details',
    the_team: 'The team',
    results: 'results',
    result: 'result',
    research: 'Search',
    search_place: 'Name, specialty, establishment.....',
    availability: 'Availability',
    means_payment: 'Payment methods',
    spoken_language: 'Spoken languages',
    choose_consult_date: `Choose the consultation date and time`,
    no_slot_today: 'No slots available today',
    around_me: 'Around me',
    no_x_is_available_at_the_moment: `No x is available at the moment`,
    list_of_exams_offered: 'List of exams offered',
    accepting_new_patients: `Accepting new patients`,
    accept_tele_consultation: 'Accept teleconsultation',
    minimum_patient_age: 'Minimum patient age',
    no_appointment: 'No records found',
    update: 'Update',
    waiting_for_confirmation: `Waiting for confirmation`,
    adsences_cancellations: 'Absences / Cancellations',
    confirmed: `Confirmed`,
    RDV_confirmed: `RDV confirmed`,
    INFORMATION: "INFORMATION",
    to_advance: `To advance`,
    delay: `Delay`,
    arrived: `Arrived`,
    in_progress: `In progress`,
    finished: `Finished`,
    paid: `Paid`,
    unjustified_absence: `Unjustified absence`,
    cancel_by_patient: `Cancelled by patient`,
    switch_tele: 'Switch to teleconsultation',
    cancel_doctor: 'Cancelled by doctor',
    to_postpone_to_prevent: `To postpone`,
    to_be_postponed_forewarned: `Postponed forewarned`,
    want_user_rights_for_this_calendar: "Would you like to set user rights for this calendar?",
    following: 'Next',
    create_a: 'Create a',
    same_rights_calendar: "Use the same rights for the following calendar:",
    user: "User",
    user_rights_on_the_calendar: "User rights on the calendar",
    language_spoken: 'Languages spoken: English, French',
    patient_must_over_12: 'Patients must be over',
    take_new_patient: 'This practitioner is taking new patients',
    take_price: 'See prices',
    sector_approved: 'Agreed sector 2',
    vital_card: 'Vital card',
    blue_card: 'Blue card',
    check: 'Check',
    who_online_book_reason: 'Who can book online?',
    before_appointment: 'before appointment',
    opening_reservation: 'Opening reservations',
    booking_times: 'Appointment booking times',
    reservation_closed: 'Reservations closed',
    patient_appointment_criteria: `Patients will be able to make an appointment for this reason {opening} in advance, and up to {close} before the appointment.`,
    price: 'Price',
    between: 'Between',
    notifications: 'Notifications',
    confirm_patient_notification: `Do you want patients to receive notifications for this appointment? (emails, SMS and push notifications)`,
    from: 'From',
    to: 'To',
    mr: `Mr.`,
    mrs: 'Mrs',
    years: 'years',
    pin_code: 'NIP',
    enter_teleport: 'Enter cell phone',
    enter_pincode: 'Please enter the NIP',
    toStart: 'Start',
    stage: 'Stage',
    email_sms_consult_start: 'An email/sms will be sent to you',
    email_sms_consult_start_to_patient: 'An email/SMS will be sent to the patient',
    appointment_confirmed_for_at: 'The appointment is confirmed for ',
    note_appointment_id: 'Take note of your appointment id',
    enter_amount: 'Enter the amount',
    name_on_card: 'Name on card',
    credit_card_num: 'Card number credit',
    bank_card: 'Bank card',
    consult_fee: 'Consultation fee',
    enter_schedule_date: 'Enter scheduled date',
    enter_practitioner_name: 'Enter the name of the referring practitioner',
    search_agenda: "Agenda search",
    add: 'add',
    Back: 'Back',
    toStart: 'Start',
    stage: 'Stage',
    consultation_location_s: 'Consultation location(s)',
    calendar_settings: 'Calendar settings',
    days_display_week: 'Days of the week you want to display on the calendar',
    visible_to_prac: "(Visible to the practitioner only)",
    hours_display_days: 'Hours of the day you want to display',
    hours_to: 'hours at',
    hours_per_block_of: 'hours per block',
    open_folder: 'Open folder',
    research_placeholder: 'Search for a professional, a specialty, an establishment...',
    notify_email: 'It is preferable to provide an email address',
    agenda_name: "Agenda name",
    calendar_rights: "Calendar access rights",
    no_access: `no access`,
    making_and_cancellation_of_appointments: `Making and Cancellation of Appointments`,
    total_management: `Total management`,
    view_only: `View only`,
    yes: 'Yes',
    No: 'No',
    no: 'no',
    create_agenda_availability: 'Create a new calendar',
    skip: 'Skip',
    submit: 'Next',
    previous: 'Previous',
    creating_a_new_calendar: `Creating a new calendar`,
    edit_calendar: `Edit Calendar`,
    read_only: `Read only`,
    appointment_create: 'Appointment management',
    appointment_management: `Appointment booking + Reading`,
    apt_mng_message: `Appointment booking + Messaging`,
    apt_mng_dossier: `Appointment booking + Messaging + Patient File`,
    search: 'Search',
    opening: `Opening`,
    click_for_reason: "Click here to add your review reason",
    calendar_grouping: 'Calendar grouping',
    view_calendars_side_by_side_in_week_view: 'Week view – See calendars side by side',
    display_of_consultation_reasons_in_day_view: 'Day view – Show consultation reasons',
    turn_off_notifications_for_new_online_appointments: 'Turn off notifications for new online appointments',
    show_calendar_resources_first: 'Show calendar resources first',
    reservation: "Online reservation rights",
    more_details: `See more schedules`,
    national_diplomas: 'National and university diplomas',
    experiences: 'Experiences',
    other_formation: 'Other Training',
    select_agenda: 'Select an agenda',
    prices: 'Rates',
    website: 'Website',
    exert_acts: 'Expertises and acts',
    presentation: "Presentation",
    Remarks: 'Remarks',
    less_details: `See less schedules`,
    configuration: 'Configuration',
    opening_ranges: "Opening consultations & exams",
    opening_ranges_calendar: "Organization of exams in the calendar",
    access_rights: "Access rights",
    consult_access: "Conditions of access to consultations",
    move_appointment: 'Move the appointment',
    cancel_appointment: 'Cancel appointment',
    delay_appointment: 'Delay appointment',
    delay_rdv: 'Delay the appointment',
    make_early_appointment: 'Make an appointment early?',
    telephone_of_consultation: 'Telephone of the consultation location',
    go_to_consultation: 'Go to consultation',
    prices_reimbursement: 'Prices and reimbursement',
    document: 'Document',
    pls_bring_on_visit: `Please bring your up-to-date vital card and, if applicable, your health insurance card or your up-to-date certificate of rights.`,
    sector_2_approved: 'Sector 2 approved',
    no_consultation: "No consultation location added for the moment",
    add_a_consultation_location: "Add a consultation location",
    no_speciality_added_yet: "No specialties added yet",
    add_speciality: "Add specialty",
    consult_access: "Conditions of access to consultations",
    make_Appointment: 'Make an appointment',
    hero_title: 'Easily book an appointment with a doctor',
    hero_subtitle: 'Find the healthcare professional that suits your needs and book your consultation in just a few clicks.',
    reason_for_exam: 'Exam reasons',
    fees_communication: 'These fees are communicated to you for information purposes only by the practitioner. They may vary depending on the type of care ultimately provided and the additional actions necessary.',
    add_a_doctor: 'Add a doctor',
    add_a_speciality: 'Add a specialty',
    where: 'Where',
    create_an_invoice: 'Create an invoice',
    you_have_selected: 'You have selected',
    confirm_appointment_time: `Confirm appointment time`,
    invoice_the_act: "Invoice the act",
    invoice_s: "Invoice(s)",
    legal_info: 'Legal information',
    rpps_num: 'RPPS number',
    no_access_appointment_create: "You do not have access to create an appointment for ",
    no_access_appointment_edit: "You do not have access to edit this appointment",
    no_access_appointment_view: "You do not have access to view this appointment.",
    no_access_appointment_delete: "You don't have access to delete this appointment",
    no_access_overture_create: `You do not have access to create an opening for `,
    near_me: 'Around me',
    waiting_for_doc: `Waiting for doctor approval`,
    Accept: 'Accept',
    reject: 'Reject',
    appointment_already_cancelled: 'Your appointment was canceled on',
    waiting_list: "Waiting list",
    to_be_moved: 'To be moved',
    add_agenda_service: "Add review reason",
    no_service_found: "No services found",
    no_service_found_step4: "You haven't added any service on Step 2",
    appointment_delay: 'Appointment late',
    appointment_early: 'Early appointment',
    retard_accept_time: 'Delay time accepted',
    delay_accept_time: "Accepted delay time",
    logged_as_doctor: "Please note that your current session is logged in as a doctor. If you would like to continue, please log in as a patient",
    set_aperture_range: "Set the opening ranges for your consultations and exams",
    hours_of_operation: "Opening hours",
    existing: "Existing",
    create: 'Create',
    please_create_availability: 'Please create availability',
    info: 'Information',
    i_create_agenda: "Edit / Create my calendar",
    empty_category_list: `No motif d'examen available`,
    empty_agenda_list: 'No agenda available',
    empty_service_list: 'No subcategories available',
    doctors: 'Doctors',
    patients: 'Patients',
    the_agenda: `I the agenda`,
    to_print: 'Print',
    printing_to_list: 'Printing list',
    of: 'From',
    at: 'at',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    days_t_print: 'Days to print',
    period_to_print: 'Period to print',
    whole_day: 'Whole day',
    morning_only: 'Morning only',
    afternoon_only: 'Afternoon only',
    show_background_color: 'Show background color',
    show_icons: 'Show icons',
    show_notes: 'Show notes',
    viewing_contact_information: 'Viewing contact information',
    condensed_display: 'Condensed display',
    options: 'Options',
    tel: 'Tel',
    delete_location: `Delete Viewing Location`,
    list: 'List',
    printing_the_calendar: 'Printing the calendar',
    print_on_a_single_page: 'Print on a single page',
    fromSmall: 'of',
    for: 'for',
    week: 'week',
    OK: "agreed",
    minimum_slot_duration: 'Duration of slots (The default duration of an appointment)',
    setup_hours_of_operation_for_atleast_one_day: `Opening hours for at least one day`,
    and: 'and',
    patient_email_phone: 'patient contact details',
    no_matches_found: 'No results',
    enter_delay_time: 'Enter the delay time in minutes',
    new_to: 'at',
    no_doctor_found: 'No doctor found',
    this_doctor: `The Doctor`,
    under_age: `does not accept patients under age`,
    not_allow_patient: `does not allow patients to make an appointment for this service`,
    not_new_patient: `does not accept new patients`,
    no_teleconsultation: `does not offer this service by teleconsultation.`,
    upload_document: `Upload a prescription`,
    description: 'Description',
    date_hour: `Date and Time`,
    enter_reservation_mode: 'Enter online reservation mode',
    enter_consultation_mode: 'Enter a consultation mode',
    enter_sub_cate: 'Enter a subcategory',
    more: '',
    accept: 'accepted',
    selected_special_exist: 'Selected specialties already exist for this doctor',
    emergencies: 'Emergencies',
    select_add_speciality: 'Select the specialty you want to add',
    apt_confirm: "Appointment confirmed",
    apt_late: "Appointment delayed",
    apt_tele: "Teleconsultation appointment",
    apt_finish: "Appointment finished",
    apt_cancel: "Appointment canceled",
    only_file_type: "Only file types",
    are_allowed: "are allowed",
    price_mode: "Price mode",
    fixed: 'Fixed',
    range: "Range",
    appointment_completed_on: "Appointment completed on",
    teleconsultation: "Teleconsultation",
    today: "Today",
    month: "Month",
    day: "Day",
    time_already_in_other_opening_hours: "Time already in other opening hours",
    a: " a ",
    the: " the ",
    the1: " the",
    there: " there ",
    make_an_appointment_earlier: 'Make an appointment earlier?',
    receive_early_alert: 'Receive an alert if a time slot is available before',
    view_map: "View Map",
    consultation_in: "Consultation in",
    location: "location",
    select_the_reason_for_consultation: 'Specify your reason for examination',
    doctor_busy_appointment: 'The doctor is busy at this time',
    service_book_between: `The service you've selected can ony be booked between `,
    enter_payment_details: `Enter payment details`,
    appointment_is_not_available: `Appointment is not available`,
    make_Appointment_teleconsultation: 'Book a teleconsultation appointment',
    delete_one_day: 'delete just for this day',
    delete_all: 'delete all',
    see_more: `See more`,
    see_less: 'See less',
    insert_patient: 'Insert patient',
    gender: 'Gender',
    select_doctor_slot: 'Select the doctor you wish to make an appointment with',
    no_doctor_service: 'No doctor found for this reason for consultation',
    select_gender: 'Select Gender',
    contact_secretary_at: 'Please contact the secretariat at: ',
    retard_not_accepte: `The doctor does not accept delay`,
    retard_exceed: `The requested delay exceeds the doctor's allowed time.`,
    reason_for_exam: 'Reasons for examinations',
    add_document: 'Add a document',
    leave_a_message: 'Leave a message',
    read_only_access: `Read-only access`,
    close: 'close',
    confirmed_cannot_delete: 'Already confirmed appointments cannot be deleted',
    choose_reasons: `Choose the reason(s) for examinations`,
    need_atleast_one: `You need to have at least one service to advance`,
    follow_create_appointment: `To create an appointment, follow the steps below in the settings menu`,
    create_configure_calendar: `Create and configure a calendar`,
    add_appointments: `Add appointments`,
    enter_appointments: 'Enter appointment',
    date_time: 'Date and Time',
    appointment_confirmed: `Your appointment is confirmed for `,
    no_tele_yet_contact: `This doctor does not currently support the teleconsultation service. Please contact the doctor's office for assistance.`,
    verify_your_phone_number: 'You have not verified your phone number. To continue, please verify your phone number by clicking the button below.',
    verify_your_phone_number_short: 'Verify your phone number',
    verify: 'Verify',
    enter_your_otp: 'Please enter the one time password to verify',
    code_send_to: 'A code has been sent to *******{{code}}',
    dont_re_otp: "Don't receive OTP?",
    resend: "Resend",
    enter_valid_otp: "Enter a valid OTP",
    invalid_phone_number: "Invalid phone number",
    are_you_sure_cancel_apt: 'Are you sure you want to cancel this appointment',
    join: 'Join',
    slot_already_reserved_continue: 'Slot already reserved. Continue to create this appointment anyway',
    prescription_document: "Prescription document",
    slot_already_reserved_continue: 'Slot already booked. Continue to add this appointment anyway',
    mins: 'mins',
    remove_agenda_service: 'Delete the review reason',
    confirm_remove_agenda_service: `Confirm the deletion of this examination reason "{{name}}" knowing that it is present in your schedule?`,
    opening_closing_time_slots: 'Agenda Settings and appointment management',
    by_patient: 'by patient',
    service_no_tele: `This service is not available via teleconsultation`,
    video_files_may_not_be_greater_than_12_mb: "Video files may not be greater than 12 MB",
    files_may_not_be_greater_than_10_MB: "File size cannot be greater than 10 MB.",
    prescription_video: "Prescription video",
    prescription_image: "Prescription image",
    video: "Video",
    image: "Image",
    document: "Document",
    please_upload_maximum_5_files: "Please upload maximum 5 files",
    view_profile: "View profile",
    view_rdv: "RDV history",
    parking_address: "Parking address",
    parking_address_mandatory: "Parking address is mandatory",
    select_create_review: "Select / Create an exam",
    select_create_service: "Select / Create an subcategory",
    choose_your_exams: "Choose your exam reasons",
    'dd/mm/yyyy': '(dd/mm/yyyy)',
    absence_on: "Absence on",
    place_absence_time: "Mark absence on calendar ",
    place_urgent_time: "Mark an urgent slot for Agenda ",
    place_break_time: "Add a break to the Calendar ",
    start_time: "Start time",
    end_time: "End time",
    short_duration: "Short duration",
    full_day: "Full day",
    multiple_days: "Multiple days",
    comments: "Comments",
    reason_for_absence_patient: "Reason for absence to inform patients",
    block_patient: "Blacklist the patient",
    deblock_patient: "Unblock the patient",
    unblock_patient: "Accept the patient again",
    block_descrip_text: "This action will limit the possibilities of contact and appointments between the patient and the practitioner.",
    unblock_descrip_text: "This action will once again allow appointments to be made and communication with the practitioner to be resumed.",
    appointment_booking_is_not_available: "Appointment scheduling with this practitioner is currently unavailable. We invite you to consult another healthcare professional for your follow-up",
    are_you_sure_block_patient: "Are you sure you want to block the patient ?",
    are_you_sure_unblock_patient: `Are you sure you want to remove the patient's "Blacklisted" status?`,
    amount_to_pay_by_patient: 'Enter an amount to be paid by the patient',
    add_a_price: 'Add a Price',
    currency: '€',
    mark_urgent_slot: "Set emergency slot",
    mark_absent_slot: "Mark an absence",
    mark_pause_slot: "Mark a break",
    urgent: "Urgent",
    pause: "Pause",
    absence: "Absence",
    do_you_want_move_appointment: "Do you want to move this appointment?",
    date_from: 'From',
    absence_edit_error: 'You cannot edit the absence now, because the appointment belonging to this absence is moved to a new date.',
    move_appointment_from_to: `Are you sure that you want to move your appointment scheduled on `,
    reschedule_appointment: 'Reschedule appointment',
    leave: "Leave",
    sick_leave: "Sick leave",
    training: "Training",
    emergencies: "Emergencies",
    choose_reason_absence: "Choose the reason for absence",
    manage_openings: "Set emergency slot",
    appointment_been_confirmed: "Your appointment has been confirmed",
    select_date_time_to_move: "Select the date and time to which you want to move the appointment :",
    agenda_list: "Agenda List",
    popup_blocked_disable_blocker: "The pop-up window has been blocked. Please disable your popup blocker and try again.",
    make_apt: "Make an appointment",
    change_opening_times: "Change opening times",
    patient_blocked: "The patient is currently blacklisted.",
    accept_patient_again: "Would you like to accept the patient again ?",
    blocked: 'Blocked',
    apt_no_cancel_before: "The appointment cannot be cancelled before one hour of the scheduled time.",
    only_type_files_are_allowed: "Only files of type {{types}} are allowed",
    honored: 'honored',
    future: 'future',
    absent: 'absent',
    cancelled: 'cancelled',
    deleted: 'deleted',
    zoom_user_does_not_exist: 'Zoom - User does not exist: {{user}}',
    you_are_logged_as: 'You are logged in as {{userType}}',
    no_result_found_search: 'No results found. Try adjusting your search or filters.',
    enter_price: "Enter the price",
    select_date_time_before_submit: 'Select the new start date and time before submitting',
    already_have_appointment: 'An appointment is already scheduled for a "{{name}}" on {{date}} at {{time}}.',
    are_you_sure_proceed: 'Are you sure you want to proceed ?',
    are_you_sure_book_appointment: 'Confirm the appointment of {{date}} at {{time}}',
    possible_duplicate_apt: 'Possible duplicate appointment',
    select_agenda_to_move: `Select the calendar for which you wish to move the appointment :`,
    other_practicioner: 'Other practitioner',
    search_patient_rdv: 'Patient Search (Appointment)',
    next_free_slot_on: 'Next available slot on ',
    select_agenda_to_book: `Select the calendar for which you want to display the next availability :`,
    next_availability: 'Next availability',
    all_my_team_agenda: `All my team's agendas`,
    choose_an_appointment: 'Choose an appointment',
    outside_proposed_opening_hours: 'Outside of the proposed hours',
    enter_valid_email: 'Enter a valid email address',
    enter_valid_dob: 'Enter a valid date of birth',
    invalid_email_domain: 'Email domain is not allowed',
    select_appointment_mode_date: 'Select the date and time at which you want to move the appointment',
    are_you_sure_you_want_to_deplacer_appointment_from_to: 'Appointment moved to: {{date}} at {{time}}',
    done: 'Done',
    return_patient_file: "Return patient file",
    no_availability: 'No availability',
    return_to_calendar: "Return to calendar",
    at1: 'at',
    app_name: 'MediKaLlink',
    default_color: 'Default color',
    deletion_of: `Delete "{{name}}"`,
    rdv_deleted: 'Appointment deleted',
    cant_view_deleted_appointment: "You can't view a deleted appointment.",
    moving_an_appointment_click_to_cancel: 'Moving the current appointment. Click here to cancel',
    confirm_date_and_time: 'Confirm the date and time',
    moving_the_appointment: 'Moving the appointment',
    original_appointment: "Original Appointment",
    service: "Service",
    contact: "Contact",
    send_message_to_patients: 'Send a message to patients',
    all_day: 'All day',
    message: 'Message',
    send: 'Send',
    other: 'Other',
    send_immediately: 'Send immediately',
    free_text: 'Free text',
    delete_absence: "Absence Removal",
    delete_pause: "Break Removal",
    delete_urgent: "Emergency Removal",
    delete_opening: "Delete this opening",
    create_new_service: 'Create a subcategory',
    create_new_category: 'Create a new review reason',
    from_to: 'from {{from}} to {{to}}',
    from1: 'on {{from}}',
    apt_date: 'Appointment date',
    to_this_patient: 'To this patient',
    to_the_doctor: 'To the doctor',
    to_other_correspondent: 'To another correspondent',
    send_a_message: 'Send a message',
    instructions: "Instructions",
    delete_instruction: "Are you sure you want to delete this instruction ?",
    add_an_internal_note: "Add an internal note",
    matriculeINS: "NS Registration Number",
    INSEE_oid: "oid",
    add_instruction: "Add a instruction",
    edit_instruction: "Edit an instruction",
    title_required: "Title is required",
    description_required: "Description is required",
    insee_verification: "INSEE verification",
    list_of_birth_names: "List of Birth Names",
    first_name_used: "First Name Used",
    last_name_used: "Last Name Used",
    supporting_document: "Supporting Document",
    place_of_birth_insee: "Place of Birth (INSEE Code)",
    national_identity_card: "National Identity Card",
    national_identity_card: "National Identity Card",
    passport: "Passport",
    residence_permit: "Residence Permit",
    eIDAS: "eIDAS",
    trusted_third_party: "Trusted Third Party",
    supporting_document: "Supporting Document",
    search_by_name_city_name: "Search for a City by Name",
    no_city_found: "No city found",
    enter_valid_matriculeINS: "Invalid INS Registration Number",
    enter_valid_oid: "Enter invalid oid",
    the_format_of_the_insi_oid_field_is_incorrect: "The format of the insi oid field is incorrect.",
    internal_notes: 'Internal notes',
    payment_failed: 'Payment failed',
    paid: 'Paid',
    delete_internal_note: 'Deletion of the internal note',
    are_you_sure_you_want_to_delete_this_note: 'Are you sure you want to delete this note ?',
    carte_vitale_data_did_not_match_to_the_patient_data: 'Carte vitale data did not match to the patient data',
    payment_cancelled: "Payment cancelled",
    orisha_patient_profile_incomplete: 'Your patient profile is incomplete in the Orisha portal. You must complete your profile before continuing.',
    do_you_wish_to_continue: 'Do you want to update your profile now ?',
    incomplete_patient_profile: 'Incomplete Patient Profile',
    no_inc_token_found_for_patient: 'No INC token found for patient.',
    patient_not_found_create_orisha_patient_profile: "It seems the patient hasn't signed upto Orisha before do you wish to create an Orisha profile for him ?",
    do_you_have_a_vitale_card: 'Do you have a vitale card ?',
    orisha: 'Orisha',
    remind_me_before: "Remind me before",
    recurrence: "Recurrence",
    message_sent_on: 'Message sent on',
    apt_day: 'The day of the appointment',
    choose: 'Choose',
    select_atleast_one_act: 'Select at least one act',
    note_of_day: 'Note of the day',
    now: 'Now',
    notify_patient_after_deletion: 'Notify patient of the deletion of this appointment',
    edit_patient: 'Edit Patient',
    edit: "Edit",
    are_you_sure_want_to_change_appointment_date: "Are you sure you want to change the appointment date ?",
    change_status: "Change status",
    change_time: "Change time",
    receive_notification_via: 'Receive appointment notifications via: SMS / Email',
    mail: 'Email',
    sms: 'SMS',
    update: 'Update',
    in_off: 'Off',
    in_tele: 'Tcs',
    at_hm: 'Home',
    opening_hours_info_l1: 'Set the hours for your consultations; all modes included',
    opening_hours_info_l2: '(in-office, at-home, and teleconsultation)',
    opening_hours_info_l3: 'In the next step, you can define the time slots for consultations',
    opening_hours_info_l4: 'in-office and at-home, and for teleconsultations',
    normal: 'Normal',
    ald: 'ALD',
    cmu: 'CMU-C',
    ame: 'AME',
    to_support: "To support",
    to_another_correspondent: "To another correspondent",
    to_my_team: "To my team",
    team: "Team",
    consultation_mode_not_supported: "Consultation mode not supported",
    dd_mm_yyyy: "DD/MM/YYYY",
    verify_your_email1: 'Please check your email address to schedule an appointment.',
    verify_your_email2: 'A confirmation link has been sent to you.',
    resend_the_link: 'Resend the link',
    send_the_link: 'Send the link',
    enter_valid_phone_number: 'Please enter a valid phone number.',
    teleconsultation_invitation: 'Teleconsultation invitation',
    accept: "Accept",
    decline: "Decline",
    invite_to_continue_discussion: "{{doctor_name}} invites you to continue the discussion via teleconsultation on {{date}} at {{time}}",
    the_fee_is: "The fee is {{fee}}",
    do_you_accept: "Do you accept?",
    no_teleconsultation_invitation_found: "No teleconsultation invitation found",
    pending: "Pending",
    modification_on_apt_of_patient_at: "Modification on the appointment of ",
    from_to: " {{from}} to {{to}}",
    deletion_on_apt_of_patient_at: "Cancellation of the appointment of ",
    apt_booked_for: "Appointment booked for ",
    end: 'End',
    instead_of: 'instead of',
    referant: "Addressed by",
    file_added: "File added",
    all_agendas: "All Agendas",
    this_appointment_was_made_within_the_last_48_hours: "This appointment was made within the last 48 hours",
    appointment_status_changed: "The appointment status has been changed from {{old}} to {{new}}.",
    appointment_status: "The appointment status is {{new}}.",
    appointment_actions_history: "Appointment Actions History",
    file_removed:"The file {{fileName}} was removed.",
    end_times:"End time",
    start_times:"Start time",
   appointment_service_changed: "The appointment service has been changed from {{old}} to {{new}}.",
   appointment_consultation_changed: "The appointment consultation has been changed from {{old}} to {{new}}.",
    file_removed:"The file {{fileName}} was removed.",
    appointment_agenda_changed:"Appointment agenda changed {{old}} to {{new}}."
}